import * as React from 'react';
import { DashboardMenuItem, Menu, MenuItemLink, useResourceDefinitions, useSidebarState } from 'react-admin';
import DefaultIcon from '@mui/icons-material/ViewList';
import ImageIcon from '@mui/icons-material/Image';
import SettingsIcon from '@mui/icons-material/Settings';
import config from '../config';


export const CustomMenu = (props) => {
    const resources = useResourceDefinitions()
    const [open] = useSidebarState();

    return (
    <Menu {...props}>
        <DashboardMenuItem />
        {Object.keys(resources).map(name => {
            var currentResource = resources[name];
            if(config.HIDDEN_MENUS.includes(name)) return null;
            if(!currentResource.hasList) return null;
            return (
                <MenuItemLink
                    key={name}
                    to={`/${name}`}
                    primaryText={
                        (currentResource.options && currentResource.options.label) ||
                        name
                    }
                    leftIcon={
                        currentResource.icon ? <currentResource.icon /> : <DefaultIcon />
                    }
                    onClick={props.onMenuClick}
                    sidebarIsOpen={open}
                />
            )
        })}
        <MenuItemLink to="/configurations" primaryText="Configuration" leftIcon={<SettingsIcon />}/>
        <MenuItemLink to="/images" primaryText="Images" leftIcon={<ImageIcon />}/>
    </Menu>
    )
};